import { render, staticRenderFns } from "./ProductReviewsCreateReview.vue?vue&type=template&id=68ef4f91&scoped=true&"
import script from "./ProductReviewsCreateReview.vue?vue&type=script&lang=js&"
export * from "./ProductReviewsCreateReview.vue?vue&type=script&lang=js&"
import style0 from "./ProductReviewsCreateReview.vue?vue&type=style&index=0&id=68ef4f91&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68ef4f91",
  null
  
)

export default component.exports